import { render } from "./ParagraphSection.vue?vue&type=template&id=4aeb9417&scoped=true&ts=true"
import script from "./ParagraphSection.vue?vue&type=script&lang=ts"
export * from "./ParagraphSection.vue?vue&type=script&lang=ts"

import "./ParagraphSection.vue?vue&type=style&index=0&id=4aeb9417&scoped=true&lang=scss"

import exportComponent from "/opt/apps/parcel4you-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4aeb9417"]])

export default __exports__